
const Hero = () => {
  return (
    <section 
      id="home" 
      className="relative min-h-screen flex items-center justify-center bg-cover bg-center bg-no-repeat"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url('https://public.readdy.ai/ai/img_res/33c30b79a9c15e4ac2254de53a22d278.jpg')`
      }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="text-white">
            <h1 className="text-5xl lg:text-6xl font-bold mb-6 leading-tight">
              Unlocking Rural Africa's 
              <span className="text-emerald-400 block">Investment Potential</span>
            </h1>
            <p className="text-xl mb-8 text-gray-200 leading-relaxed">
              Partner with TS Dotyeni International to discover extraordinary investment opportunities in Africa's rural markets. We collaborate with governments and investors to create sustainable development that transforms communities while delivering exceptional returns.
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <button 
                onClick={() => window.REACT_APP_NAVIGATE('/smart-villages')}
                className="bg-emerald-600 hover:bg-emerald-700 text-white px-8 py-4 rounded-full font-semibold transition-colors cursor-pointer whitespace-nowrap"
              >
                Explore Opportunities
              </button>
              <button className="border-2 border-white text-white px-8 py-4 rounded-lg hover:bg-white hover:text-gray-900 transition-colors duration-200 font-semibold text-lg whitespace-nowrap cursor-pointer">
                Download Research
              </button>
            </div>
          </div>
          <div className="hidden lg:block">
            {/* Space for hero image - content handled by background */}
          </div>
        </div>
      </div>
      
      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 text-white animate-bounce">
        <i className="ri-arrow-down-line text-2xl"></i>
      </div>
    </section>
  );
};

export default Hero;
